import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useTenant } from "./useTenant";

export interface Entity {
  id: string;
  org_id: string;
  family_id: string;
  client_id: string;
  name: string;
  type: 'family' | 'spv' | 'trust';
  created_at: string;
}

export function useEntity() {
  const { orgId, familyId, isSFO, isMFO } = useTenant();

  const { data: entities = [], isLoading } = useQuery({
    queryKey: ['entities', orgId, familyId],
    queryFn: async () => {
      if (!orgId) return [];
      
      let query = supabase
        .from('entities')
        .select('*')
        .eq('org_id', orgId);
      
      // For MFO, filter by selected family
      if (isMFO && familyId) {
        query = query.eq('family_id', familyId);
      }
      
      // For SFO, use the default family
      if (isSFO && familyId) {
        query = query.eq('family_id', familyId);
      }
      
      const { data, error } = await query.order('name');
      
      if (error) throw error;
      return data || [];
    },
    enabled: !!orgId,
  });

  return {
    entities,
    isLoading,
    hasMultipleEntities: entities.length > 1,
  };
}
